import { useState } from 'react';
import { updateTableSavedTableState } from '../helpers/tableHelpers';

export const useResetSavedTableState = () => {
  const [resetTableValue, setResetTableValue] = useState(null);

  const resetTableState = (tableName, fieldName, newValue) => {
    if (tableName && fieldName) {
      setResetTableValue(`${Math.floor(Math.random() * Date.now())}`);
      updateTableSavedTableState(tableName, fieldName, newValue);
    }
  };

  return [resetTableValue, resetTableState];
};
